import React, { useState } from "react";
import { jobs } from "../jobs";
import { FaAngleDoubleRight } from "react-icons/fa";

const Experience = () => {
  const [value, setValue] = useState(0);
  const { company, dates, duties, title } = jobs[value];
  return (
    <section className="experience">
      <div className="container">
        <h2>Experience</h2>
        <div className="underline"></div>
        <div className="jobs-center">
          <div className="btn-container">
            {jobs.map((item, index) => {
              return (
                <button
                  key={item.id}
                  onClick={() => setValue(index)}
                  className={`job-btn ${index === value && "active-btn"}`}
                >
                  {item.company}
                </button>
              );
            })}
          </div>
          <article className="job-info">
            <h3>{title}</h3>
            <h4>{company}</h4>
            <p className="job-date">{dates}</p>
            {duties.map((duty, index) => {
              return (
                <div key={index} className="job-desc">
                  <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
                  <p>{duty}</p>
                </div>
              );
            })}
          </article>
        </div>
      </div>
    </section>
  );
};

export default Experience;
